import React from "react";
import { irrelevantWords } from "./IrrelevantWords";

// Modify highlightPartialKeyword to output HTML string for `customTextRenderer`
export function highlightPartialKeyword(text, keyword) {
  if (!text) return "No data";
  if (!keyword) return text;

  const keywordParts = keyword
    .match(/[\p{Script=Han}\p{Script=Arabic}\p{L}\p{N}]+/gu)
    ?.filter(
      (kw) => kw.length >= 3 && !irrelevantWords.includes(kw.toLowerCase())
    );

  const regex = new RegExp(`(${keywordParts.join("|")})`, "gi");

  // Split the text based on the regex and wrap matched parts in <mark> tags
  const parts = text.split(regex);
  return parts
    .map((part) =>
      keywordParts.some((kw) => part.toLowerCase() === kw.toLowerCase())
        ? `<mark style="background-color: yellow;">${part}</mark>`
        : part
    )
    .join(""); // Join the array into a single HTML string
}

export default function HighlightedText({ paragraph, keyword, onClick }) {
  const highlightedContent = highlightPartialKeyword(paragraph, keyword);

  return (
    <p
      onClick={onClick || (() => {})} // Default to a no-op function if no onClick is provided
      style={{ cursor: onClick ? "pointer" : "default" }}
      dangerouslySetInnerHTML={{ __html: highlightedContent }}
    />
  );
}
